import axios, { AxiosRequestConfig } from 'axios';

import UserService from './UserService';

/*
 * HttpService is a file with functions to make axios call and update the keycloak token if needed
 */

const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
};

const _axios = axios.create();

const configure = () => {
  _axios.interceptors.request.use((config: AxiosRequestConfig) => {
    if (UserService.isLoggedIn()) {
      const cb = () => {
        if (config.headers) {
          config.headers.Authorization = `Bearer ${UserService.getToken()}`;
        }
        return Promise.resolve(config);
      };
      return UserService.updateToken(cb);
    }
  });
};

const getAxiosClient = () => _axios;

const getApiAddress = () => {
  if (process.env.REACT_APP_API_GATEWAY === '') {
    return 'https://admin.my-evs-dev.com/api';
  }

  return process.env.REACT_APP_API_GATEWAY || 'localhost:3000';
};

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
  getApiAddress,
};

export default HttpService;
